// Copyright (C) 2023 Explore.dev, Unipessoal Lda - All Rights Reserved
// Use of this source code is governed by a license that can be
// found in the LICENSE file.

import React from 'react';
import { NotificationService } from '../models/Notification';

export default React.createContext<NotificationService>({} as unknown as NotificationService);
